if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      //this part of the script is for the faq to be displayed on top of the page
      //this happens when there is a scrollTo parameter in the URL
    
      this.queryString = window.location.search;
      if(this.queryString) {
        this.urlParams = new URLSearchParams(this.queryString);
        this.scrollTo = this.urlParams.get('scrollTo')
        if (this.urlParams.get('addSections')) {
          this.addSections = this.urlParams.get('addSections').split(",")
        }
        
        //console.log('addSections', this.addSections)
        this.displayFAQ()
      }
      
      
      //these variables are for the sliding add to cart button at the header
      //this will only show in the product detail page(PDP). hence the inclusion of this.productInfoBtnClose in the if statement below
      //to this date of writing aug 2 when the sliding add to cart is clicked, the product form will have the position sticky
      //when the sliding add to cart button is clicked (it is the pink button at the top of the screen) and user will click the true add to cart button
      
      //now we will change that so whenever the sliding add to cart button is clicked product will automatically be added to cart
      //to need to click the true add to cart button in the product form again
      this.slidingAddToCartContainer = document.querySelector('.sliding-add-to-cart-container')
      this.productInfoBtnClose = document.querySelector('.product__info-wrapper-close-btn')
      if( this.slidingAddToCartContainer && this.productInfoBtnClose && !this.slidingAddToCartContainer.getAttribute("data-btn-function") ) {
        
        this.slidingAddToCartContainer.addEventListener('click', () => {
          if (this.form.requestSubmit) {
            this.form.requestSubmit();
          } else {
            this.form.submit();
          }
        })
          
      }
      
      //these variables too are for the sliding add to cart button at the header
      this.addToCartObserve = document.querySelector('.main-product-qty-and-btn')
      this.addToCartObserveBounds = {};
      this.elementCont = document.getElementById('distance-container2')
      if (this.addToCartObserve && this.addToCartObserveBounds ) {
        this.createObserver();
      }

      // this is the actual add to cart button logic start
      this.form = this.querySelector('form');
      this.variantIdInput.disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButtonText = this.submitButton.querySelector('span');

      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
      // this is the actual add to cart button logic end


  
    }

    ///////////////////////////////////////////////////////////////////////////////START OF THE FUNCTIONS

    displayFAQ() {

        if(this.scrollTo) {
          this.faqElement = document.querySelector(`#${this.scrollTo}`).parentElement
          this.faqElement.classList.add('faq-grg-to-fixed')
          const faqCloseBtn = document.createElement("button");
          faqCloseBtn.innerHTML = 'x'
          faqCloseBtn.classList.add('faqCloseBtn')
          //faqCloseBtn.disabled = true;

          if(this.addSections) {
            this.faqElement.classList.add('faq-grg-to-fixed-more-sec')
            this.addSections.forEach(section => {
              const clonedSection = document.querySelector(`#${section}`).cloneNode(true);
              this.faqElement.appendChild(clonedSection);
            })
          }


          if(this.faqElement.querySelector('.reveal-more-btn')) {
            setTimeout( () => {
              this.faqElement.querySelector('.reveal-more-btn').click();
            }, 500)
          }


          this.faqElement.appendChild(faqCloseBtn)
          faqCloseBtn.addEventListener('click', ()=> {
            this.hideFAQModal(faqCloseBtn)

          })
        } else {
          return
        }
    }

    hideFAQModal(faqCloseBtn) {
      this.faqElement.classList.remove('faq-grg-to-fixed')

      if(this.addSections) {
        this.addSections.forEach(section => {
          this.faqElement.removeChild(this.faqElement.querySelector(`#${section}`));
        })
      }

      this.faqElement.scrollIntoView({behavior: 'smooth', block: 'center'})
      faqCloseBtn.style.display = 'none'
    }

    

    //this can also be an alternate if we cannot click the show more button with JS
    revealAccordionElement(accordionContainer) {
      let accordionWrapper = accordionContainer.querySelector('.pmd-faq__accordian-faq__box.scrollbar--thin')
      //const accordionElement = accordionContainer.querySelectorAll('product__accordion')
      accordionWrapper.childNodes.forEach(element => {
        //element.classList.remove('hide-class')
        //console.log(element)
        element.classList.remove('hide-class')
      });

      accordionContainer.querySelector('.reveal-more-btn').classList.add('hide-class');
      accordionContainer.querySelector('.hide-more-btn').classList.remove('hide-class');
    }

  // universal function that can add and remove a class from an element start
    addClassFromListUniv(element, className) {
        element.classList.add(className)
    }

    removeClassFromListUniv(element, className) {
        element.classList.remove(className)
    }

    // universal function that can add and remove a class from an element end


    //create an observer for the add to cart button
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        if(entries[0].isIntersecting && this.slidingAddToCartContainer) {
          this.slidingAddToCartContainer.classList.remove('show-sliding-cart')
        }

        if(!entries[0].isIntersecting && this.slidingAddToCartContainer) {
          this.slidingAddToCartContainer.classList.add('show-sliding-cart')
        }
      }, {rootMargin: "-150px 0px 0px 0px"});
      
      observer.observe(this.addToCartObserve);

    }

    connectedCallback() {
      // if rebuy's smart cart exists, disable the native shopify cart drawer
      if (window.Rebuy && window.Rebuy._status !== 'initialized') {
        this.disableForm();
      }
    }

    disableForm() {
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
    }

    enableForm() {
      this.submitButton.removeAttribute('aria-disabled');
      this.submitButton.classList.remove('loading');
      this.querySelector('.loading-overlay__spinner').classList.add('hidden');

    //   window.onload = function() {
    //     const queryString = window.location.search;
    //     if(queryString) {
    //         const urlParams = new URLSearchParams(queryString);
    //         const scrollTo = urlParams.get('scrollTo')
    //         if(scrollTo) {
    //             setTimeout(()=> {
    //               const element = document.getElementById(scrollTo)
    //               if(element) {
    //                 element.scrollIntoView({behavior: 'smooth', block: 'center'});
    //               }
    //             }, 10)
    //         }
    //     }
  
    // };
    
                setTimeout(()=> {
                  const element = document.querySelector('.faqCloseBtn')
                  if(element) {
                    element.classList.add('showfaqCloseBtn');
                  }
                }, 10)

    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButtonText.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(response);
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper =
        this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    toggleSubmitButton(disable = true, text) {
      if (disable) {
        this.submitButton.setAttribute('disabled', 'disabled');
        if (text) this.submitButtonText.textContent = text;
      } else {
        this.submitButton.removeAttribute('disabled');
        this.submitButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    get variantIdInput() {
      return this.form.querySelector('[name=id]');
    }






  });
}
